import { lazy } from "react";

export const MobileNav = lazy(() => import("./MobileNav"));
export const SiteHeaderNav = lazy(() => import("./SiteHeaderNav"));
export const NavbarToggleButton = lazy(() => import("./NavbarToggleButton"));
